import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with publishable key
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// Subscription plan configurations (single starter plan)
const starterMonthlyPrice = process.env.REACT_APP_STRIPE_PRICE_STARTER_MONTHLY || '';
const starterAnnualPrice = process.env.REACT_APP_STRIPE_PRICE_STARTER_ANNUAL || '';

const starterPlanConfig = {
  monthly: {
    priceId: starterMonthlyPrice,
    amount: 15.0,
    displayAmount: '£15.00',
    billingLabel: 'Billed monthly',
  },
  annual: {
    priceId: starterAnnualPrice,
    amount: 99.0,
    displayAmount: '£99.00',
    monthlyEquivalent: '£8.25/month',
    billingLabel: 'Billed annually',
  },
  yearly: {
    priceId: starterAnnualPrice,
    amount: 99.0,
    displayAmount: '£99.00',
    monthlyEquivalent: '£8.25/month',
    billingLabel: 'Billed annually',
  },
};

export const SUBSCRIPTION_PLANS = {
  starter: starterPlanConfig,
  hobbyist: starterPlanConfig,
  pro: starterPlanConfig,
};

// No platform commission - sellers keep all revenue except payment processing fees
export const PLATFORM_COMMISSION_RATE = 0.00;

// Calculate seller payout (no commission, only Stripe fees)
export const calculateSellerPayout = (mealPrice) => {
  // Stripe fee: 1.5% + 20p for European cards
  const stripeFee = (mealPrice * 0.015) + 0.20;
  const sellerPayout = mealPrice - stripeFee;

  return {
    mealPrice: parseFloat(mealPrice.toFixed(2)),
    stripeFee: parseFloat(stripeFee.toFixed(2)),
    sellerPayout: parseFloat(sellerPayout.toFixed(2)),
  };
};

// Stripe API helper functions (to be called from Edge Functions)
export const stripeHelpers = {
  // Format amount for Stripe (convert to smallest currency unit)
  formatAmountForStripe: (amount, currency = 'gbp') => {
    return Math.round(amount * 100);
  },

  // Format amount for display (convert from smallest currency unit)
  formatAmountFromStripe: (amount, currency = 'gbp') => {
    return amount / 100;
  },
};
